/**
 * Grace Organic - Motion.js Scroll Animations
 * CSS handles all entrance/float animations (no JS opacity manipulation).
 * Motion.js only powers scroll-triggered reveals site-wide.
 */

import { animate, inView, stagger } from 'https://cdn.jsdelivr.net/npm/motion@12/dist/motion.js';

function initScrollAnimations() {

  // ── Section headings ──
  document.querySelectorAll([
    '.grace-trust-bar h2',
    '.grace-benefits__heading',
    '.grace-reviews__title',
    '.grace-bundle-cta__title',
    '.grace-founder__heading',
    '.featured-collection h2',
  ].join(', ')).forEach((el) => {
    inView(el, () => {
      animate(el, { opacity: [0, 1], y: [24, 0] }, { duration: 0.7, easing: [0.16, 1, 0.3, 1] });
    }, { margin: '-10% 0px' });
  });

  // ── Benefit / trust items ──
  document.querySelectorAll(
    '.grace-trust-bar__items, .grace-benefits__grid, .grace-benefits__list'
  ).forEach((group) => {
    inView(group, () => {
      animate(
        Array.from(group.children),
        { opacity: [0, 1], y: [40, 0] },
        { duration: 0.6, delay: stagger(0.1), easing: [0.16, 1, 0.3, 1] }
      );
    }, { margin: '-8% 0px' });
  });

  document.querySelectorAll('.grace-trust-bar__item, .grace-benefits__item').forEach((el) => {
    inView(el, () => {
      animate(el, { opacity: [0, 1], y: [36, 0] }, { duration: 0.6, easing: [0.16, 1, 0.3, 1] });
    }, { margin: '-5% 0px' });
  });

  // ── Product cards ──
  document.querySelectorAll('.product-grid, .collection').forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll('.card-wrapper, .product-card-wrapper, li.grid__item'));
    if (!cards.length) return;
    inView(grid, () => {
      animate(
        cards,
        { opacity: [0, 1], y: [30, 0], scale: [0.96, 1] },
        { duration: 0.55, delay: stagger(0.09), easing: [0.16, 1, 0.3, 1] }
      );
    }, { margin: '-5% 0px' });
  });

  // ── Review cards ──
  const reviewCards = document.querySelectorAll('.grace-reviews__card');
  if (reviewCards.length) {
    inView(reviewCards[0], () => {
      animate(
        Array.from(reviewCards),
        { opacity: [0, 1], x: [-24, 0] },
        { duration: 0.65, delay: stagger(0.12), easing: [0.16, 1, 0.3, 1] }
      );
    }, { margin: '-5% 0px' });
  }

  // ── Founder section ──
  const founderImg = document.querySelector('.grace-founder__image-wrap, .grace-founder__img');
  if (founderImg) {
    inView(founderImg, () => {
      animate(founderImg, { opacity: [0, 1], x: [-40, 0] }, { duration: 0.8, easing: [0.16, 1, 0.3, 1] });
    }, { margin: '-10% 0px' });
  }
  const founderText = document.querySelector('.grace-founder__copy, .grace-founder__content');
  if (founderText) {
    inView(founderText, () => {
      animate(founderText, { opacity: [0, 1], x: [40, 0] }, { duration: 0.8, easing: [0.16, 1, 0.3, 1] });
    }, { margin: '-10% 0px' });
  }

  // ── Bundle CTA ──
  ['.grace-bundle-cta__title', '.grace-bundle-cta__btn'].forEach((sel, i) => {
    const el = document.querySelector(sel);
    if (el) {
      inView(el, () => {
        animate(el, { opacity: [0, 1], y: [20, 0] }, { duration: 0.6, delay: i * 0.15, easing: [0.16, 1, 0.3, 1] });
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}
